import Slider from "react-slick";
import styles from "../GlobalBanner/GlobalBanner.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { useState, useEffect, useRef } from "react";
import { selectSliderElementsGen } from "@/helpers/generalHelper";
import Ticker from "@/components/common/Counter";
import { getOverallBenefitValue } from "@/helpers/charityHelper";

const GlobalBannerCarousel = (props) => {
  let settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 350,
    autoplaySpeed: 3500,
    arrows: false,
    fade:props.transitionType=='Fade'?true:false
  }
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 600px)");

  const sliderRef= useRef(null); 
  const [tabPressed, setTabPressed] = useState(false);

  const [tickerData, setTickerData] = useState({});
  const [overallBenefit, setOverallBenefit] = useState(null);

  // Fetch overall benefit data ONCE per page load
  useEffect(() => {
    let isMounted = true;
    const fetchOverallBenefit = async () => {
      try {
        const resp = await getOverallBenefitValue();
        if (isMounted) setOverallBenefit(resp);
      } catch (error) {
        console.error("Error fetching overall benefit data", error);
        if (isMounted) setOverallBenefit(null);
      }
    };
    // Only fetch if at least one message needs it
    if (props.bannerMessages?.some(m => m.tickerEnabled && m.syncTotalImpact)) {
      fetchOverallBenefit();
    }
    return () => { isMounted = false; };
  }, []);

  // Build tickerData using cached overallBenefit
  useEffect(() => {
    const bannerMessages = Array.isArray(props.bannerMessages) ? props.bannerMessages : [];
    const data = {};
    for (const [index, message] of bannerMessages.entries()) {
      if (message.tickerEnabled && message.syncTotalImpact && overallBenefit && overallBenefit.days_of_school) {
        const totalBenefitValue = overallBenefit.days_of_school * 3;
        data[index] = {
          tickerFrom: totalBenefitValue - 50000,
          tickerTo: totalBenefitValue,
        };
      } else {
        data[index] = undefined;
      }
    }
    setTickerData(data);
  }, [props.bannerMessages, overallBenefit]);

  // to handle global banner tab indexing
    useEffect(() => {
      // If the view is mobile, exit early
      if (isMobile) return;

      // Function to handle key events
      const handleKeyEvent = (event) => {
        try {
          switch (event?.key) {
            case "Tab":
              setTabPressed(event.type === "keydown");
              if (event.type === "keydown" && !tabPressed) {
                selectSliderElementsGen(sliderRef, true); // General function to select slider elements
              }
              break;
            default:
              break;
          }
        } catch (error) {
          reportError("tab indexing global banner carousel", error); // Log error using reportError function
        }
      };

      // Add event listeners
      window.addEventListener("keydown", handleKeyEvent);
      window.addEventListener("keyup", handleKeyEvent);

      // Clean up event listeners when the component unmounts or dependencies change
      return () => {
        window.removeEventListener("keydown", handleKeyEvent);
        window.removeEventListener("keyup", handleKeyEvent);
      };
    }, [tabPressed, isMobile]);

  const slides = props?.bannerMessages?.map((e,index)=>{
    let ticker = tickerData[index] || {};
    let message = isMobile && e?.mobileMessage ? e?.mobileMessage: isTablet && e?.tabletMessage? e?.tabletMessage : e?.desktopMessage;
    let href = isMobile && e?.mobileMessageLink ? e?.mobileMessageLink: isTablet && e?.tabletMessageLink? e?.tabletMessageLink : e?.desktopMessageLink;
    return (
      <div key={index} className={`x-large-sm small-xs ${styles.slide_wrapper}`}>
        {/* Render the banner message as a link. If no href is provided in builder, apply the disabled_link class to make it non-clickable */}
        {/* Fallback to "#" if href is not provided */}
        <a tabIndex={0} className={`${styles.slide} ${!href ? styles.disabled_link : ""}`} key={index} href={href || "#"}>{message}</a>
        {e?.tickerEnabled && (
          // Render the ticker wrapper as a link. If no href is provided in builder, apply the disabled_link class to make it non-clickable
          // Fallback to "#" if href is not provided
          <a href={href || "#"} className={`${styles.ticker_wrapper} ${!href ? styles.disabled_link : ""}`} style={{borderColor: props.fontColor }}>
            {e?.enableText ? (
              <span className={styles.ticker_text}>{e?.bannerText}</span>
            ) : (
              <>
              <span className={styles.ticker_value}>
                {((ticker.tickerFrom || e?.from) && (ticker.tickerTo || e?.to)) ? <span>$</span> : null}
                <Ticker key={`${ticker.tickerFrom}-${ticker.tickerTo}`} from={ticker.tickerFrom || e?.from} end={ticker.tickerTo || e?.to} duration={1000}/>
                {((ticker.tickerFrom || e?.from) && (ticker.tickerTo || e?.to)) ? <span>+</span> : null}
              </span>
               <span>  raised so far</span>
              </>
            )}
          </a>
        )}
      </div>
    )
  })

  return(
    <div className={styles.global_banner}
      style = {{
        color: props.fontColor,
        fontFamily : props.fontStyle == "Aktiv Grotesk" ? "Aktiv Grotesk Ex Basic" : props.fontStyle || "",
      }}>
        <Slider {...settings} ref={sliderRef}>
          {slides}
        </Slider>
    </div>
  )
};

export default GlobalBannerCarousel;
